import React from 'react';
import {Modal} from 'react-bootstrap';
import {Trans} from 'react-i18next';
import {Link} from 'react-router-dom';
import storeUtils from '../../utils/storeUtils';
import {useDispatch, useSelector} from 'react-redux';
import smbUtils from '../../utils/smbUtils';
import authDao from '../../dao/authDao';
import {setAccountSummary} from './reducers';

const UpgradeCompletedModal = ({show, setShow, version = 2}) => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {customerId} = smbUtils.customerInfo(auth);

  const modalBody = () => {
    switch (version) {
      case '1':
        return (
          <>
            <p>
              <Trans i18nKey="c.a.upgrade.modal.body3">
                You are now able to explore and learn more about the new
                features:
              </Trans>
            </p>
            <div>
              <li style={{listStyleType: 'none'}}>
                <Link
                  to="/general-settings/location-management"
                  style={{textDecoration: 'underline'}}
                >
                  <Trans i18nKey="p.g.store.management.title">
                    Location Management
                  </Trans>
                </Link>
              </li>
              <li style={{listStyleType: 'none'}}>
                <Link
                  to="/client/client-list"
                  style={{textDecoration: 'underline'}}
                >
                  <Trans i18nKey="p.s.listcustomer.theme">Client List</Trans>
                </Link>
              </li>
              <li style={{listStyleType: 'none'}}>
                <Link
                  to="/skincare-pro/ui-configuration/landing-page"
                  style={{textDecoration: 'underline'}}
                >
                  <Trans i18nKey="p.s.uiconfiguration.title">
                    UI Configuration
                  </Trans>
                </Link>
              </li>
            </div>
          </>
        );
      default:
        return (
          <>
            <p>
              <Trans i18nKey="c.a.upgrade.modal.body3.v2">
                The system update is complete. Now you can set up the new
                settings by clicking the links below:
              </Trans>
            </p>
            <div className="row">
              <div
                className="col-6"
                style={{borderRight: '1px dashed #ebedf2'}}
              >
                <Link
                  to="/skincare-pro/ui-configuration/overview"
                  style={{
                    textDecoration: 'underline',
                  }}
                >
                  <Trans i18nKey="c.a.upgrade.modal.ui.configuration.detection">
                    UI Configuration - Skincare Detection
                  </Trans>
                  &nbsp;
                  <i className="fa fa-external-link-alt" />
                </Link>
                <img
                  style={{maxWidth: '100%'}}
                  alt=""
                  src={
                    'https://plugins-media.makeupar.com/smb/story/2024-12-31/cad01577-5bff-4a1b-bca1-ae2dd8099617.jpg'
                  }
                />
                <li>
                  <Trans i18nKey="c.a.upgrade.modal.body3.item1">
                    New skin concerns available for Premium Plan users: Tear
                    Trough, facial areas for Wrinkles and Pores. Enable them now
                    to detect more detailed skin results!
                  </Trans>
                </li>
                <li>
                  <Trans i18nKey="c.a.upgrade.modal.body3.item2">
                    Updated face marks for all skin concerns.
                  </Trans>
                </li>
              </div>
              <div className="col-6">
                <Link
                  to="/skincare-pro/recommendation-rule"
                  style={{
                    textDecoration: 'underline',
                  }}
                >
                  <Trans i18nKey="c.a.upgrade.modal.recommendation.settings">
                    Recommendation Rule Settings
                  </Trans>
                  &nbsp;
                  <i className="fa fa-external-link-alt" />
                </Link>
                <img
                  style={{maxWidth: '100%'}}
                  alt=""
                  src={
                    'https://plugins-media.makeupar.com/smb/story/2024-12-31/612e0482-8dae-4974-9126-cbb9c22bbb9a.png'
                  }
                />
                <li>
                  <Trans i18nKey="c.a.upgrade.modal.body3.item3">
                    New skin concerns available for AI to analyze and recommend
                    products: Tear Trough, facial areas for Wrinkles and Pores.
                    (For Premium Plan users)
                  </Trans>
                </li>
                <li>
                  <Trans i18nKey="c.a.upgrade.modal.body3.item4">
                    Confirm the options and regenerate AI Recommendation Rules
                    to see the new results.
                  </Trans>
                </li>
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <>
      <Modal
        size="lg"
        show={show}
        centered
        backdrop={'static'}
        enforceFocus={true}
      >
        <Modal.Header closeButton={false}>
          <Modal.Title>
            <Trans i18nKey="c.a.upgrade.modal.title3">Update Complete</Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalBody()}</Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-outline-secondary"
              onClick={() => {
                authDao.loadAuth().then(json => {
                  dispatch(setAccountSummary(json));
                });
                storeUtils.removeHideUpdatedModal(customerId);
                setShow(false);
              }}
            >
              <Trans i18nKey="p.p.s.view.close">Close</Trans>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpgradeCompletedModal;
